import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	PARALLAX: '[data-fragment="ParallaxComponent.parallax"]',
	LAYER: '[data-fragment="ParallaxComponent.layer"]',
};

class ParallaxComponent extends WebComponent {
	constructor(props) {
		super(props);
	}
	didMount() {
		this.parallaxElement = this.element.querySelector(fragments.PARALLAX);
		window.addEventListener('scroll', () => {
			  this.transformLayer();
		}, false);
		window.addEventListener('resize', () => {
			this.transformLayer();
		}, false);
		var _self = this;
		document.onreadystatechange = function(){
			if(document.readyState === 'complete'){
				_self.transformLayer();
			}
		}
	}

	transformLayer = () => {
		this.layerElement = this.element.querySelectorAll(fragments.LAYER);
		var pageMotive = this.element.querySelector('.page-motive__svg');
		var imgSizeWidth = pageMotive.naturalWidth;
		var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		var imgSizeHeight = pageMotive.clientHeight;
		this.parallaxElement.style.height = (imgSizeHeight - 2) + 'px';
		for (let i = 0; i < this.layerElement.length; i++) {
			let layer = this.layerElement[i];
			if (w >= imgSizeWidth && imgSizeWidth > 0) {
				layer.style.width = imgSizeWidth + 'px';
				layer.style.height = imgSizeHeight + 'px';
				pageMotive.style.width = imgSizeWidth + 'px';
			} else {
				layer.style.width = w + 'px';
				layer.style.height = imgSizeHeight + 'px';
				pageMotive.style.width = w + 'px';
			}
			let speed = layer.getAttribute('data-speed');
			layer.style.transform = 'translate(-50%, -' + (window.pageYOffset * speed / this.layerElement.length) + 'px)';
		}
	}

	willUnMount() {
		this.layerElement = null;
	}
}

export default ParallaxComponent;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/ParallaxComponent/ParallaxComponent.js